import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { setIsMoreJob, setSelectedJobData } from '../UserInfo/UserSlice';

export const onSetDefaultData = createAsyncThunk(
    "Global/onSetDefaultData",
    async (_, { dispatch }) => {
        dispatch(setIsMoreJob(false))
        dispatch(setSelectedJobData({}))
    }
);

const initialState = {
    currentFilterSection: 'Explore-Jobs',
    blogsStatus: 'new',
    applicationStepper: 'applied',
    toastContent: '',
    toastType: '',
    collapsedData: false,
    currentSettingType: 'account-information',
    userProfile: {},
    currentSaveJobData: {},
    userType: 'employee',
    currentJob: {},
    currentJobStatus: {},
    searchParameters: {},
    internalSearchParameter: {},
    onSearchValues: {},
    currentBoostJobData: null,
    specificJobDetails: {},
    draftData: {},
    orgJDStatus: 'open',
    shortlistUser: {},
    candidateDetails: {},
    storeSelectedJobSatus: {},
    currencyname: '',
    requiredSkillsData: {},
    isSelectedApplicationData: false,
    currentSkillCheckData: {},
    userinfoPrevData: {},
    storeEditQualificationId: {},
    storeEditExperianceData: {},
    isSucessMessage: false,
    isErrorMessage: false,
    sucessMessage: '',
    errorMessage: '',
    storeCreatedOrderData: {},
    notifications: {},
    notificationCount:0,
    notificationLoad: false,
    openDrwaerSM:false,
    currentOrgActive:{}
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setCurrentFilterSection: (state, action) => {
            state.currentFilterSection = action.payload
        },
        setBlogStatus: (state, action) => {
            state.blogsStatus = action.payload
        },
        setApplicationStatus: (state, action) => {
            state.applicationStepper = action.payload
        },
        setToastContent: (state, action) => {
            state.toastContent = action.payload
        },
        setToastType: (state, action) => {
            state.toastType = action.payload
        },
        setCollapsedData: (state, action) => {
            state.collapsedData = action.payload
        },
        setCurrentInformation: (state, action) => {
            state.currentSettingType = action.payload
        },
        setUserProfile: (state, action) => {
            state.userProfile = action.payload
        },
        setCurrentJobData: (state, action) => {
            state.currentSaveJobData = action.payload
        },
        setUserType: (state, action) => {
            state.userType = action.payload
        },
        setCurrentJob: (state, action) => {
            state.currentJob = action.payload
        },
        setCurrentJobStatus: (state, action) => {
            state.currentJobStatus = action.payload
        },
        setSearchParameters: (state, action) => {
            state.searchParameters = action.payload
        },
        setInternalSearchParameter: (state, action) => {
            state.internalSearchParameter = action.payload
        },
        setOnsearchValues: (state, action) => {
            state.onSearchValues = action.payload
        },
        setCurrentBoostJobData: (state, action) => {
            state.currentBoostJobData = action.payload
        },
        setSpecificJobDetails: (state, action) => {
            state.specificJobDetails = action.payload
        },
        setDraftData: (state, action) => {
            state.draftData = action.payload
        },
        setOrgJDStatus: (state, action) => {
            state.orgJDStatus = action.payload
        },
        setSortlistUser: (state, action) => {
            state.shortlistUser = action.payload
        },
        setCandidateDetails: (state, action) => {
            state.candidateDetails = action.payload
        },
        setStoreSelectedJobSatus: (state, action) => {
            state.storeSelectedJobSatus = action.payload
        },
        setCurrencyName: (state, action) => {
            state.currencyname = action.payload
        },
        setRequiredSkillsData: (state, action) => {
            state.requiredSkillsData = action.payload
        },
        setSelectedApplicationData: (state, action) => {
            state.isSelectedApplicationData = action.payload
        },
        setCurrentSkillCheckData: (state, action) => {
            state.currentSkillCheckData = action.payload
        },
        setUserInfoPrevData: (state, action) => {
            state.userinfoPrevData = action.payload
        },
        setStoreEditQualificationId: (state, action) => {
            state.storeEditQualificationId = action.payload
        },
        setStoreEditExperianceData: (state, action) => {
            state.storeEditExperianceData = action.payload
        },
        setIsSuccess: (state, action) => {
            state.isSucessMessage = action.payload.isSucess
            state.sucessMessage = action.payload.message
        },
        setIsError: (state, action) => {
            state.isErrorMessage = action.payload.isError
            state.errorMessage = action.payload.message
        },
        setStoreCreatedOrderData: (state, action) => {
            state.storeCreatedOrderData = action.payload
        },
        settNotifications: (state, action) => {
            state.notifications = action.payload
        },
        setNotificationLoad: (state, action) => {
            state.notificationLoad = action.payload
        },
        setOpenDrawerSM:(state, action)=>{
            state.openDrwaerSM = action.payload
        },
        setNotificationCount:(state, action)=>{
            state.notificationCount = action.payload
        },
        setCurrentOrgActive:(state, action)=>{
            state.currentOrgActive = action.payload
        }
    }
});

export const
    { setCurrentFilterSection, setBlogStatus, setApplicationStatus, setToastContent, setToastType,
        setCollapsedData, setCurrentInformation, setUserProfile, setCurrentJobData, setUserType,
        setCurrentJob, setCurrentJobStatus, setInternalSearchParameter, setOnsearchValues, setCurrentBoostJobData,
        setSearchParameters, setSpecificJobDetails, setDraftData, setOrgJDStatus, setSortlistUser, setCandidateDetails,
        setStoreSelectedJobSatus, setCurrencyName, setRequiredSkillsData, setSelectedApplicationData,
        setCurrentSkillCheckData, setUserInfoPrevData, setStoreEditQualificationId, setStoreEditExperianceData,
        setIsError, setIsSuccess, setStoreCreatedOrderData, setNotificationLoad, settNotifications , setOpenDrawerSM , 
        setNotificationCount ,setCurrentOrgActive
    } = globalSlice.actions;
export default globalSlice.reducer;
